// ReturnPolicy.jsx
import React from "react";
import Layout from "../../components/user/Layout";

const ReturnPolicy = () => {
  return (
    <Layout>
      <div className="return-policy py-22 ps-40 pe-40">
        <h2 className="d-flex justify-content-center fw-bold">Return Policy</h2>
        <p>
          The following return policy applies to items purchased online through Power Trading Mobile App and e-portal.
        </p>

        <section>
          <ol>
            <li>
              The order cannot be returned once material is delivered as per order.
            </li>
            <li>
              Generally, there will not be any quality problems. We take care of all measures to avoid quality issues. However, in case there is an issue of quality, we will settle the issue as stated below:
              <ol type="a">
                <li>
                  <strong>Wrong Item Delivered:</strong> The order can be replaced only when the delivered items are different from the ordered items. Return claims can be raised by calling our contact number (<strong> </strong>). The material will be replaced only if it is received in the same form as it was delivered. The claim must be made as soon as the material is received, but not later than <strong>24 hours</strong> after delivery.
                </li>
                <li>
                  <strong>Quality Problem:</strong> In case of any quality complaint about the material, claims must be submitted via email or in writing within <strong>three days</strong> of receiving the material. 
                  <ul>
                    <li>Change of colour of material will <strong>not</strong> be considered a quality issue, and no complaints will be entertained on this account.</li>
                    <li>If the delivered material is in a <strong>rusted or pitted condition</strong>, a quality complaint may be raised. In such cases, the material will be replaced with proper material at our own cost.</li>
                  </ul>
                </li>
                <li>
                  Material must be in <strong>prime condition</strong> as delivered by us.
                </li>
              </ol>
            </li>
          </ol>
        </section>
      </div>
    </Layout>
  );
};

export default ReturnPolicy;